<template>
  <ul class="p navigation">
    <div class="navigation__cta">
      <transition name="fade">
        <span class="header__links header__links--desktop">
          <module-link
            v-for="headerLink in headerLinks"
            :key="headerLink.name"
            class="header__link ttu tdn fw-extrabold link"
            color="secondary"
            :link="headerLink.name"
            :label="headerLink.label"
            :external="false"
          />
        </span>
      </transition>
      <transition
        name="fade"
        mode="out-in"
      >
        <module-button
          v-if="!isAuthenticated && !signin"

          button="primary"
          label="Sign In"

          @click.native="openModal(`login`)"
        />
        <ui-user-info v-if="isAuthenticated" />
      </transition>
    </div>
  </ul>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { arrayIncludes } from 'services/array';

// Models
import menus from 'models/global/menu';

// Modules
import ModuleButton from 'modules/Button';
import ModuleLink from 'modules/Link';
import ModuleIcon from 'modules/Icon';

// Ui
import UiUserInfo from 'ui/UserInfo';

// Export
export default {
  name: `ui-navigation`,

  // Components
  components: {
    ModuleLink,
    ModuleButton,
    ModuleIcon,
    UiUserInfo,
  },

  // Data
  data() {
    return {
      menus,
      headerLinks: [],
    };
  },
  computed: {
    ...mapGetters(`auth`, [
      `isAuthenticated`,
      `user`,
      `userRole`,
      `userIsRole`,
    ]),
    signin() {
      const signupRoutes = [
        `register-patient`,
        `register-dentist`,
        `login`,
        `logout`,
        `register`,
        `set-password`,
        `authReset`,
        `authConfirm`,
      ];
      return arrayIncludes(signupRoutes, this.$route.name);
    },
  },

  // Methods
  methods: {
    ...mapActions(`modals`, [
      `openModal`,
    ]),
    ...mapActions(`dashboard`, [
      `toggleDashboard`,
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?297e64ef